import React from "react";

/** Minimal Swiss table wrapper. Children must be <thead><tbody> content. */
export default function DataTable({ columns, rows, empty = "No records yet.", testId }) {
  return (
    <div className="grid-surface overflow-x-auto" data-testid={testId}>
      <table className="w-full border-collapse text-left text-sm">
        <thead>
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className="bg-stone-50 border-b border-stone-200 text-stone-500 uppercase text-[10px] tracking-[0.15em] font-bold py-3 px-4"
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center text-stone-400 py-10 text-sm"
              >
                {empty}
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr
                key={row.id || i}
                className="border-b border-stone-100 hover:bg-stone-50 transition-colors"
              >
                {columns.map((c) => (
                  <td key={c.key} className="py-3 px-4 text-stone-800 align-middle">
                    {c.render ? c.render(row) : row[c.key] ?? "—"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
